import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    modal: {
      padding: "0 20px 12px",
      borderRadius: 3,
      "& .MuiPaper-root": {
        minWidth: 336,
        width: 336
      }
    },
    dialogTitle: {
      padding: "16px 20px 0",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      height: 66,
      display: "flex",
      alignItems: "center",
      fontSize: 18,
      "&.calendarOpen": {
        padding: 0,
        height: 44,
        justifyContent: "center",
        fontSize: 16,
        borderBottom: `1px solid ${primary.light}`
      }
    },
    dialogContent: {
      padding: "0 20px",
      height: 380,
      "&.withDateField": {
        height: 380
      },
      "&.calendarOpen": {
        height: 400,
        "&.sixWeekMonth": {
          height: 440
        }
      }
    },
    dialogActions: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "0 8px 26px",
      "&.calendarOpen": {
        justifyContent: "space-between",
        padding: "0 16px 24px"
      }
    },
    note: {
      color: primary.main,
      marginBottom: 22
    },
    contentLabel: {
      display: "flex",
      alignItems: "center",
      color: primary.dark,
      height: 30,
      marginTop: 8
    },
    contentValue: {
      display: "flex",
      alignItems: "center",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      height: 36,
      color: primary.main
    },
    actionButton: {
      height: 32,
      width: 91,
      fontSize: 16,
      borderRadius: 2,
      color: primary.dark,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      "&:not(:first-child)": {
        marginLeft: 2
      }
    },
    confirmButton: {
      color: secondary.dark
    },
    calendarButton: {
      width: 144,
      height: 38,
      borderRadius: 2,
      color: "#333",
      border: "1px solid #333",
      "& .MuiButton-startIcon": {
        margin: 0,
        "& .MuiSvgIcon-root": {
          fontSize: 14
        }
      }
    },
    confirmDateButton: {
      backgroundColor: secondary.dark,
      borderColor: "transparent",
      boxShadow: "none",
      color: "#fff",
      "&:hover": {
        backgroundColor: secondary.dark,
        boxShadow: "none"
      }
    },
    backArrowIcon: {
      marginLeft: 1
    },
    datePickerField: {
      width: "100%",
      "& .MuiInputBase-root": {
        height: 36,
        fontSize: 14
      },
      "&.calendarOpen": {
        marginBottom: 100,
        marginTop: 166,
        "&.sixWeekMonth": {
          marginBottom: 128
        }
      }
    },
    popoverRoot: {
      maxHeight: "60%",
      "& > div:first-child": {
        display: "none"
      }
    },
    paperElevation8: {
      boxShadow: "none"
    },
    calendarPaper: {
      transitionDuration: "0s !important",
      marginLeft: 7,
      marginBottom: -10,
      height: 300,
      overflowY: "hidden",
      "& .MuiPickersDay-day": {
        width: 32,
        height: 29,
        borderRadius: 22,
        margin: "5px 6px",
        "& .MuiTypography-root": {
          fontSize: 13
        },
        "& .MuiTouchRipple-root": {
          display: "none"
        }
      },
      "& .MuiPickersCalendarHeader-dayLabel": {
        width: 40
      },
      "& .MuiPickersBasePicker-pickerView": {
        overflow: "hidden"
      },
      "&.sixWeekMonth": {
        height: 320,
        marginBottom: 0,
        marginTop: -10,
        "& .MuiPickersBasePicker-pickerView": {
          height: 320,
          justifyContent: "start"
        }
      }
    },
    calendarIcon: {
      fontSize: 18
    },
    selectedDate: {
      color: primary.main,
      height: 20,
      margin: "0 -20px 0",
      padding: "26px 20px 0",
      borderTop: "1px solid #eee"
    },
    selectedDateText: {
      height: 20,
      textAlign: "center",
      marginTop: 4,
      "&:first-child": {
        marginTop: 0
      },
      "&.hasNoChanges": {
        color: primary.light
      }
    }
  };
});
